export default __webpack_public_path__ + "static/media/IMG_2697.1c676218.JPG";